module.exports = __webpack_public_path__ + "static/media/logo-dark-bg.48fc5eaa.png";